/** Storezone — useProgress hook */
import { useContext } from 'react'
import { ProgressContext, type ProgressContextValue } from '@/contexts/ProgressContext'

export function useProgress(): ProgressContextValue {
  return useContext(ProgressContext)
}
